export namespace ApiSectionNamespace {
  //configuration section
  export enum EConfigurationApiKeys {
    CONFIG_CART_URL = '/config/cart',
    CONFIG_USER_URL = '/config/user',
    CONFIG_CHECKOUT_URL = '/config/checkout',
    CONFIG_AGGREGATED_CHECKOUT_APP_SETTINGS_URL = '/aggregation/config/checkoutApp',
    CONFIG_PAYMENT_URL = '/configuration/payment',
  }

  //translation section
  export enum ETranslationApiKeys {
    TRANSLATION_URL = '/translations/byKey',
    TRANSLATION_URL_2 = '/translations/byKeys',
  }

  //upselling section
  export enum EUpsellingApiKeys {
    UPSELLING_PRODUCT_URL = '/upselling',
    UPSELLING_PRODUCT_DETAIL = '/upselling/detail/{catalogId}',
  }

  //Repay section
  export enum ERepayApiKeys {
    ORDER_REPAY_VALIDATE_URL = '/order/repay/validate',
  }

  //Order as last time section
  export enum EOrderAsLastTimeParfumsApiKeys {
    ORDER_AS_LAST_TIME_VALIDATE_LAST_ORDER_PARFUMS_URL = '/orderaslasttime/',
  }

  //Order as last time section
  export enum EOrderAsLastTimeApiKeys {
    ORDER_AS_LAST_TIME_VALIDATE_LAST_ORDER_URL = '/order/orderAsLastTime/validate/address',
    ORDER_AS_LAST_TIME_VALIDATE_CART_URL = '/order/orderAsLastTime/validate/cart',
  }

  //cartPage section
  export enum ECartPageApiKeys {
    CART_PAGE_CONTENT_URL = '/cartPage/cartContent',
    CART_PAGE_PRODUCTS_URL = '/cartPage/products',
    CART_PAGE_UPSELLING_URL = '/cartPage/products/upselling',
    CART_PAGE_AGGREGATED_CONFIGURATION = '/aggregation/cartPage/configuration',
    CART_PAGE_ADD_VOUCHERS_URL = '/cartPage/vouchers/add/{voucherCode}',
    CART_PAGE_VOUCHERS_URL = '/cartPage/vouchers/{voucherCode}',
    CART_PAGE_FREE_DELIVERY_PRODUCTS_URL = '/cartPage/products/freedelivery',
  }

  //cart section
  export enum ECartApiKeys {
    CART_CONTENT_URL = '/cart/cartContent',
    CART_VOUCHERS_ADD_URL = '/cart/vouchers',
    CART_VOUCHERS_DELETE_URL = '/cart/vouchers/{voucherCode}',
    CART_ECO_PACKAGING_URL = '/cart/ecoPackaging',
    CART_INSURANCE_URL = '/cart/insurance',
    CART_GIFT_PACKAGING_URL = '/cart/giftPackaging',
    CART_GIFT_PACKAGING_V2_URL = '/cart/giftPackaging/v2',
    CART_GIFTS_SELECTED_ADD_URL = '/cart/gifts/selection',
    CART_GIFTS_SELECTED_DELETE_URL = '/cart/gifts/selection/{itemId}',
    CART_GIFTS_AUTO_INSERTED_URL = '/cart/gifts/autoInserted',
    CART_UPSELLING_URL = '/cart/upselling',
    CART_TRY_IT_FIRST_URL = '/cart/tryItFirst',
    CART_ENGRAVING_URL = '/cart/engraving',
    CART_FUND_RAISING_URL = '/cart/fundRaising',
    CART_DISCOVERY_BOX_URL = '/cart/discoveryBox/{itemId}',
    CART_VALIDATE_URL = '/cart/validate',
  }

  //web content section
  export enum EWebContentApiKeys {
    WEB_CONTENT_BASE_URL = 'webContent/richTexts',
  }

  //reservation page section
  export enum EReservationPage {
    CART_CONTENT_URL = '/reservationPage/cartContent/{cartId}',
  }

  //payment section
  export enum EPaymentApiKeys {
    PAYMENT_PAYPAL_CREATE_ORDER = '/payment/paypal/orders/create',
    PAYMENT_PAYPAL_GET_ORDER = '/payment/paypal/orders/{payPalOrderId}',

    PAYMENT_ADYEN_GET_PAYMENT_METHODS = '/payment/adyen/payments/aggregatedmethods',
    PAYMENT_ADYEN_INITIALIZE_WEB_PAYMENT = '/payment/adyen/payments/initiate/oalt/web',
    PAYMENT_ADYEN_REPAY_WEB_PAYMENT = '/payment/adyen/payments/initiate/repay/web',
    PAYMENT_ADYEN_REPAY_ADDITIONAL_INFO = '/payment/adyen/payments/details/repay',
    PAYMENT_ADYEN_ADDITIONAL_INFO = '/payment/adyen/payments/details',
    PAYMENT_ADYEN_APPLEPAY_VALIDATION_URL = '/payment/adyen/payments/applepayvalidationurl',
    PAYMENT_ADYEN_INITIALIZE_TOKEN_PAYMENT = '/payment/adyen/payments/initiate/oalt/token',
    PAYMENT_ADYEN_INITIALIZE_BLIK_PAYMENT = '/payment/adyen/payments/initiate/oalt/web/blik',
    PAYMENT_ADYEN_INITIALIZE_IDEAL_PAYMENT = '/payment/adyen/payments/initiate/oalt/web/ideal',
    PAYMENT_ADYEN_INITIALIZE_TWINT_PAYMENT = '/payment/adyen/payments/initiate/oalt/web/twint',
    PAYMENT_ADYEN_INITIALIZE_SWISH_PAYMENT = '/payment/adyen/payments/initiate/oalt/web/swish',
    PAYMENT_ADYEN_INITIALIZE_BCMC_MOBILE_PAYMENT = '/payment/adyen/payments/initiate/oalt/web/bancontactmobile',
    PAYMENT_ADYEN_INITIALIZE_MOBILEPAY_PAYMENT = '/payment/adyen/payments/initiate/oalt/web/mobilepay',

    PAYMENT_PAYPAL_INITIATE_OALT = '/payment/paypal/initiate/oalt',
    PAYMENT_PAYPAL_PROCESS = '/payment/paypal/process',

    PAYMENT_PRZELEWY_INITIALIZE_WEB_PAYMENT = '/payment/przelewy24/payments/initiate',
    PAYMENT_PRZELEWY_INITIALIZE_OALT_PAYMENT = '/payment/przelewy24/payments/initiate/oalt',
    PAYMENT_GLOBAL_PAYMENTS_PROCESS_RESPONSE = '/payment/globalpayments/processresponse',
    PAYMENT_GLOBAL_PAYMENTS_PAYMENT_LINK = '/payment/globalpayments/paymentlink',
    PAYMENT_PRZELEWY_ADDITIONAL_INFO = '/payment/przelewy24/payments/detail/{orderId}',
    PAYMENT_PRZELEWY_GET_PAYMENT_METHODS = '/payment/przelewy24/payments/methods',
    PAYMENT_PRZELEWY_INITIATE_TRANSACTION = '/payment/przelewy24/payment/initiate',
    PAYMENT_PRZELEWY_VERIFY_TRANSACTION = '/payment/przelewy24/payment/notify',
    PAYMENT_TRACKER_PAYMENT = '/payment/tracker/payments',
    PAYMENT_MULTIBANCO_PAYMENT_INFO = '/payment/adyen/multibancoInfo',
    PAYMENT_ADYEN_INITIALIZE_MBWAY_PAYMENT = '/payment/adyen/payments/initiate/oalt/web/mbway',
  }

  export enum EOrderApiKeys {
    CREATE_ORDER = '/order/create/{orderId}',
    INITIALIZE_ORDER = '/order/initialize',
    ORDER_DETAIL = '/order/get',
    CHECK_ORDER_EXISTS = '/order/exists',
  }

  export enum EDeliveryModalApiKeys {
    GET_CONFIGURATION = '/config/deliveryModal',
    WEB_SETTINGS = '/deliveryModal/webSettings',
    MAP_LOCALIZATION = '/deliveryModal/map/localization',
    PICK_UP_POINTS = '/deliveryModal/pickUpPoints',
  }

  export enum EDeliveryApiKeys {
    VALIDATE_AIR_DELIVERY_ZIP = '/delivery/airtransport/validate',
    DELIVERY_AND_PAYMENT_PAGE_CONTENT = '/dapPage/content',
    PERSONAL_PICKUP_BY_TERM = '/delivery/personalPickUp/{carrierId}/{serviceType}/{pickUpPointType}/{findLike}/term/{term}',
    PERSONAL_PICKUP_BY_ADDRESS_CODE = '/delivery/personalPickUp/{carrierId}/{addressCode}',
    PERSONAL_PICKUP_BY_TERM_EXTERNAL = '/delivery/personalPickUp/{carrierId}/pickuppoints/term/{term}',
    PERSONAL_PICKUP_BY_TYPE_EXTERNAL = '/delivery/personalPickUp/{carrierId}/pickuppoints/{pickUpPointType}/term/{term}',
    UPDATE_DELIVERY_AND_PAYMENT_PAGE_CONTENT = '/dapPage/update',
    GET_VALIDATION_RULES_BY_COUNTRY = '/delivery/country/validationrules',
  }

  export enum ESummaryPageApiKeys {
    SUMMARY_PAGE_CONTENT = '/summaryPage/content',
    SUMMARY_PAGE_VALIDATIONS = '/summaryPage/country/rules',
  }
}
